//
// MessageText - Component for displaying text content within chat messages
// Handles both string text (with line break conversion) and JSX content
// Use this component for all text display within chat messages
//

import classNames from 'classnames';
import PropTypes from 'prop-types';

import LineBreaksToBr from '../../../../text/LineBreaksToBr';

const MessageText = function MessageText({
  message,
  author,
  italic,
  bold,
  underline,
  differentiate,
  feedback,
  context,
  className,
}) {
  const txtClassName = classNames(
    'break-words text-base',
    {
      'text-left': author,
      'text-right': !author,
      'italic': (italic || differentiate),
      'font-bold': bold,
      underline,
      'opacity-70 mb-1': differentiate,
      'bg-pxUiOk/40 py-0.5 px-2 mb-2 w-full rounded-lg': feedback,
      'text-black/40': context,
    },
    className,
  );

  if (typeof message === 'string') {
    return (
      <p className={txtClassName}>
        <LineBreaksToBr text={message} />
      </p>
    );
  }

  return (
    <span className={txtClassName}>
      {message}
    </span>
  );
};

MessageText.propTypes = {
  message: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
  author: PropTypes.string,
  italic: PropTypes.bool,
  bold: PropTypes.bool,
  underline: PropTypes.bool,
  differentiate: PropTypes.bool,
  feedback: PropTypes.bool,
  context: PropTypes.bool,
  className: PropTypes.string,
};

export default MessageText;
